import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const SpecialEventContainer = styled.div<{ $addMargin?: boolean }>`
    ${BaseStyle.Mixins.fontStyles.ui['18b']}
    display: flex;
    justify-content: center;
    text-align: center;
    color: ${({ theme }) => theme.Text.secondary};
    ${({ $addMargin }) => ($addMargin ? 'margin-bottom: 16px;' : '')}
`;

export const SpecialEventImage = styled.img`
    display: flex;
    max-height: 50px;
    width: 100%;
    padding: 0 10px;
    justify-content: center;
`;
